/* Portada. Todo el texto y las fotos vienen de los ajustes de cada sección: aquí
   solo se rellena lo que sale del catálogo (cifras, productos, marcas, familias).
   Cada bloque busca su contenedor; si la sección no está puesta, no hace nada. */
(function () {
  var P = GP.productos, esc = GP.esc, clp = GP.fmt, foto = GP.foto, url = GP.url;
  var $ = GP.$, $$ = GP.$$;
  function num(el, attr, porDefecto) {
    var v = el && +el.getAttribute(attr);
    return v > 0 ? v : porDefecto;
  }

  /* ---------- cifras de los textos editables ---------- */
  GP.pintarDatos();

  /* ---------- banner: el producto destacado de cada uno ---------- */
  var FILTRO = {
    arabe:     function (p) { return p.k === 'arabe' && p.fo === 'perfume' && p.ins; },
    disenador: function (p) { return p.k === 'disenador' && p.fo === 'perfume' && p.p > 60000; },
    nicho:     function (p) { return p.k === 'nicho' && p.fo === 'perfume'; },
    caro:      function (p) { return p.fo === 'perfume' && p.p > 40000; }
  };
  $$('[data-gp-vitrina]').forEach(function (slot, k) {
    var modo = slot.getAttribute('data-gp-vitrina');
    var mano = slot.getAttribute('data-gp-producto');
    var p = null;
    if (modo === 'manual' && mano) {
      p = P.filter(function (x) { return x.h === mano; })[0];
    } else if (FILTRO[modo]) {
      var l = P.filter(function (x) { return x.img && FILTRO[modo](x); })
               .sort(function (a, b) { return b.p - a.p; });
      p = l[Math.min(k, l.length - 1)];
    }
    if (!p) { slot.parentNode.removeChild(slot); return; }
    slot.outerHTML =
      '<a class="hero__vit" href="' + url(p) + '">' +
        '<img src="' + foto(p) + '" alt="' + esc(p.n) + '">' +
        '<p class="m">' + esc(p.b || '') + '</p>' +
        '<p class="n">' + esc(p.n) + '</p>' +
        '<p class="p">' + clp(p.p) + '</p>' +
        (GP.cuota(p.p) ? '<p class="c">' + GP.cuota(p.p) + '</p>' : '') +
        '<span class="btn btn--oro btn--sm btn--bloque">Ver la ficha</span></a>';
  });
  var dots = $('#heroDots');
  if (dots) {
    dots.innerHTML = $$('.hero__slide').map(function () {
      return '<button class="hero__dot" type="button" aria-label="Ir al banner"><i></i></button>';
    }).join('');
  }

  /* ---------- tira de marcas ---------- */
  var tiraCaja = $('#logos');
  if (tiraCaja) {
    var tope = num(tiraCaja.parentNode, 'data-gp-tira', 40);
    var repetidos = {}, tira = [];
    P.forEach(function (p) {
      if (!p.logo || repetidos[p.logo] || tira.length >= tope) return;
      repetidos[p.logo] = 1;
      tira.push('<a href="' + GP.T({ m: p.b }) + '">' +
        '<img src="' + p.logo + '" alt="' + esc(p.b) + '" loading="lazy"></a>');
    });
    var g = tira.join('');
    tiraCaja.innerHTML = '<div class="logos__g">' + g + '</div>' +
                         '<div class="logos__g" aria-hidden="true">' + g + '</div>';
  }

  /* ---------- comparador de dupes ---------- */
  var cajaDupes = $('#dupes');
  if (cajaDupes) {
    var pares = P.map(function (p) { var e = GP.equiv(p); return e ? { p: p, e: e } : null; })
      .filter(Boolean).filter(function (x) { return x.p.fo === 'perfume'; })
      .sort(function (a, b) { return b.e.pct - a.e.pct; })
      .slice(0, num(cajaDupes, 'data-gp-pares', 4));
    cajaDupes.innerHTML = pares.map(function (x) {
      var p = x.p, o = x.e.o;
      function cara(q, rotulo, ml) {
        return '<a class="dupe__cara" href="' + url(q) + '"><img src="' + foto(q) + '" alt="' + esc(q.n) + '" loading="lazy">' +
          '<small>' + rotulo + '</small><strong>' + esc(q.n) + '</strong><b>' + clp(q.p) + '</b>' +
          '<small style="letter-spacing:.03em;text-transform:none">' + q.ml + ' ml · ' + clp(Math.round(ml)) + ' el ml</small></a>';
      }
      return '<article class="dupe__par"><div class="dupe__caras">' +
        cara(p, 'El dupe', x.e.mlA) + '<div class="dupe__vs">VS</div>' + cara(o, 'El original', x.e.mlB) +
        '</div><div class="dupe__pie"><span>Dupe declarado de ' + esc(p.ins) + '</span>' +
        '<span>El mililitro cuesta <b>' + x.e.pct + '% menos</b></span></div></article>';
    }).join('');
  }

  /* ---------- invitación al test ---------- */
  var mosaico = $('#mosaicoTest');
  if (mosaico) {
    mosaico.innerHTML = P.filter(function (p) { return p.img && p.fo === 'perfume'; })
      .sort(function () { return Math.random() - 0.5; }).slice(0, 6)
      .map(function (p) {
        return '<div><img src="' + foto(p) + '" alt="" loading="lazy"><span>' + clp(p.p) + '</span></div>';
      }).join('');
  }
  var sorpresa = $('#sorpresa');
  if (sorpresa) sorpresa.addEventListener('click', GP.sorprendeme);

  /* ---------- filas de productos (la sección se puede repetir) ---------- */
  var FUENTE = {
    nuevos:  function (l) { return l.sort(function (a, b) { return b.i - a.i; }); },
    baratos: function (l) { return l.sort(function (a, b) { return a.p - b.p; }); },
    caros:   function (l) { return l.sort(function (a, b) { return b.p - a.p; }); },
    dupes:   function (l) { return l.filter(function (p) { return p.ins; }).sort(function (a, b) { return b.i - a.i; }); },
    testers: function (l) { return l.filter(function (p) { return p.te; }).sort(function (a, b) { return b.i - a.i; }); }
  };
  var REGLA = {
    'perfumes-arabes': function (p) { return p.k === 'arabe'; },
    'disenador': function (p) { return p.k === 'disenador'; },
    'nicho-cat': function (p) { return p.k === 'nicho'; },
    'testers': function (p) { return p.te; },
    'dupes': function (p) { return !!p.ins; },
    'body-mist': function (p) { return p.fo === 'mist'; },
    'hombre': function (p) { return p.g === 'Hombre'; },
    'mujer': function (p) { return p.g === 'Mujer'; },
    'unisex': function (p) { return p.g === 'Unisex'; },
    'bajo-20-mil': function (p) { return p.p < 20000; },
    'nicho': function (p) { return p.k === 'nicho'; },
    'perfumes-de-autor': function (p) { return !!p.au; },
    'catalogo': function () { return true; }
  };
  var ORDENA = {
    nuevo:   function (a, b) { return b.i - a.i; },
    caro:    function (a, b) { return b.p - a.p; },
    barato:  function (a, b) { return a.p - b.p; },
    aleatorio: function () { return Math.random() - 0.5; }
  };
  $$('[data-gp-fuente]').forEach(function (caja) {
    var modo = caja.getAttribute('data-gp-fuente');
    var col = caja.getAttribute('data-gp-coleccion');
    var cuantos = num(caja, 'data-gp-cuantos', 10);
    // hay que sacar los agotados ANTES de cortar: si no, se cortaba a 20 y GP.grid()
    // los quitaba después, y la fila terminaba con cuatro productos.
    var l = P.filter(function (p) { return p.img && GP.visible(p); });
    if (modo === 'coleccion' && col) {
      if (REGLA[col]) l = l.filter(REGLA[col]);
      else if (col.indexOf('aroma-') === 0) {
        var fam = col.slice(6);
        l = l.filter(function (p) {
          return (p.f || []).some(function (f) { return GP.sinAcento(f).toLowerCase() === fam; });
        });
      }
      l = l.sort(ORDENA[caja.getAttribute('data-gp-orden')] || ORDENA.nuevo);
    } else {
      l = (FUENTE[modo] || FUENTE.nuevos)(l);
    }
    // una fila sin productos no se muestra: es preferible a un título con nada debajo
    if (!l.length) {
      var sec = caja.closest('.shopify-section') || caja.closest('section');
      if (sec) sec.hidden = true;
      return;
    }
    caja.innerHTML = GP.grid(l.slice(0, cuantos));
    GP.flechasFila(caja);
  });

  /* ---------- familias con foto ---------- */
  var cajaFam = $('#familias');
  if (cajaFam) {
    var fotos = {};
    $$('script[data-gp-fam]', cajaFam).forEach(function (s) {
      try { fotos[s.getAttribute('data-gp-fam')] = JSON.parse(s.textContent); } catch (e) {}
    });
    cajaFam.innerHTML = GP.famTop(num(cajaFam, 'data-gp-cuantas', 8)).map(function (f) {
      var enFam = P.filter(function (p) { return (p.f || []).indexOf(f.n) >= 0; });
      var c = {};
      enFam.forEach(function (p) { GP.notasDe(p).forEach(function (x) { c[x] = (c[x] || 0) + 1; }); });
      var top = Object.keys(c).sort(function (a, b) { return c[b] - c[a]; }).slice(0, 3).join(' · ');
      var img = fotos[f.n] || GP.amb('fam-oriental');
      return '<a class="fam" href="' + GP.T({ fam: f.n }) + '">' +
        (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
        '<b>' + esc(f.n) + '</b><span>' + f.c + ' fragancias</span>' +
        '<p class="fam__notas">' + esc(top || '—') + '</p></a>';
    }).join('');
  }

  /* ---------- marcas ---------- */
  var cajaMarcas = $('#marcas');
  if (cajaMarcas) {
    cajaMarcas.innerHTML = GP.marcaTop(num(cajaMarcas, 'data-gp-cuantas', 16)).map(function (m) {
      var l = GP.marcaLogo(m.n);
      return '<a class="marca" href="' + GP.T({ m: m.n }) + '">' +
        (l ? '<img src="' + l + '" alt="' + esc(m.n) + '" loading="lazy">' : esc(m.n)) +
        '<span>' + m.c + ' referencias</span></a>';
    }).join('');
  }

  /* ---------- reseñas ---------- */
  /* Ficha del local en Google. El cid es el identificador estable del lugar. */
  var GOOGLE = 'https://maps.google.com/?cid=6009021572008017159';
  var cajaRese = $('#resenas');
  if (cajaRese) {
    var todas = GP.reviews || [];
    var R = todas.slice(0, num(cajaRese, 'data-gp-cuantas', 5));
    var prom = todas.length ? (todas.reduce(function (s, r) { return s + r.r; }, 0) / todas.length) : 0;
    var garantia = cajaRese.getAttribute('data-gp-garantia') || '';
    cajaRese.innerHTML =
      '<div class="rese__res"><div class="rese__nota">' + prom.toFixed(1) + '</div><div class="estrellas">★★★★★</div>' +
        '<p class="rese__n">' + todas.length + ' opiniones publicadas</p>' +
        (garantia ? '<p class="rese__n" style="margin-top:14px;border-top:1px solid var(--linea);padding-top:14px">' +
          esc(garantia) + '</p>' : '') + '</div>' +
      '<div class="rese__lista">' + R.map(function (r) {
        /* Las de Google hablan del local, no de un producto: por eso no dicen «Sobre X»
           y llevan el enlace a la ficha, que es lo que Google pide al reproducirlas. */
        var pie = r.g
          ? '<a class="rev__goo" href="' + GOOGLE + '" target="_blank" rel="noopener">Opinión en Google</a>' +
            (r.cuando ? '<span> · ' + esc(r.cuando) + '</span>' : '')
          : 'Sobre ' + esc(r.p);
        return '<article class="rev"><div class="rev__top"><strong>' + esc(r.n) + '</strong>' +
          '<span class="estrellas">' + '★'.repeat(r.r) + '</span></div>' +
          '<p>' + esc(r.t) + '</p><p class="rev__prod">' + pie + '</p></article>';
      }).join('') + '</div>';
  }

  /* ---------- si está abierto el local ---------- */
  var estado = $('#estadoHoy');
  if (estado) {
    var est = GP.estadoLocal();
    estado.innerHTML = '<span style="display:inline-flex;align-items:center;gap:9px">' +
      '<i style="width:8px;height:8px;border-radius:50%;background:' + (est.abierto ? '#3FD08A' : '#7A7166') + ';display:inline-block"></i>' +
      '<b style="color:var(--papel)">' + esc(est.texto) + '</b></span><br>' +
      '<span style="color:#B0A79B">' + esc(est.retiro) + '</span>';
  }

  /* ---------- últimas fichas vistas ---------- */
  var vistos = $('#vistos');
  if (vistos) vistos.innerHTML = GP.bloqueVistos();
})();
